import React, { useEffect, useState } from "react";
import {
  IEditarArea,
  InitialEditarArear,
} from "../../../Interfaces/IPERC/IArea";
import IPERCService from "../../../services/IPERCService";
import { IResponsePost } from "../../../Interfaces/base/IResponse";
import { useBoolean } from "@fluentui/react-hooks";

export const useEditarArea = (model, loadTabla) => {
  const [response, setResponse] = useState<IResponsePost>(null!);
  const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
    useBoolean(false);

  const [modelrequestEditar, setModelRequestEditar] =
    useState<IEditarArea>(InitialEditarArear);

  const onChangeTextField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string,
    areaId?: string
  ) => {
    if (event !== undefined) {
      if (newValue !== undefined) {
        if (areaId) {
          setModelRequestEditar({
            areaId: areaId,
            nombre: newValue,
          });
        }
      }
    }
  };

  const handlerEditarArea = () => {
    ocultarMensaje();
    onEnviar();
    IPERCService.actualizarArea(modelrequestEditar)
      .then((res) => {
        if (res.status === 200) {
          setResponse({
            codigoMensaje: res.data.codigoMensaje,
            mensaje: res.data.mensaje,
          });
          onCancelar();
          loadTabla()
        }
      })
      .catch((err) => {
        onCancelar();
      });
  };
  const ocultarMensaje = () => {
    setResponse(null!);
  };
  useEffect(() => {
    setModelRequestEditar(model);
  }, [model]);

  return {
    modelrequestEditar,
    onChangeTextField,
    ocultarMensaje,
    handlerEditarArea,
    response,
    isSend,
  };
};
